import "./App.css";
import Blog from "./component/blog/blog";
import BlogPage from "./component/blog/blogPage";
import Career from "./component/career/career";
import Certificate from "./component/certificate/certificate";
import Clubassociation from "./component/clubassociation/clubassociation";
import Contact from "./component/contact/contact";
import Healthcare from "./component/healthcare/healthcare";
import Homepage from "./component/home/homepage";
import Housingsociety from "./component/housingSociety/housingsociety";
import News from "./component/news/news";
import TabSlider from "./component/tap/tap";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Term from "./component/term/term";
import About from "./component/about/aboutOld";
import Education from "./component/education/education";
import Pricing from "./component/pricing/pricing";
import Backend from "./component/career/backend";
import Event from "./component/event/event";
import EventsPage from "./component/event/eventpage";
import Payout from "./component/payout/payout";
import Blog2 from "./component/blog/Blog1";
import Blog5 from "./component/blog/Blog5";
import Blog6 from "./component/blog/Blog6";
import Blog7 from "./component/blog/Blog7";
import Blog8 from "./component/blog/Blog8";
import Blog9 from "./component/blog/Blog9";
import Blog10 from "./component/blog/Blog10";
import Blog11 from "./component/blog/Blog11";
import Blog12 from "./component/blog/Blog12";
import Blog13 from "./component/blog/Blog13";
import Blog14 from "./component/blog/Blog14";
import Blog3 from "./component/blog/Blog3";
import PartnerPage from "./component/partner/partner";
// import { Toaster } from "react-hot-toast";
import RecurringPayments from "./component/recurring/recurring";
import LeadGenerationExecutive from "./component/career/leadGenerationExecutive";
import ManagerIT from "./component/career/managerIT";
import MarketingStrategist from "./component/career/marketingStrategist";
import PrMarketting from "./component/career/prMarketting";
import TechSupport from "./component/career/techSupport";
import Gff from "./component/event/gff";
import AboutUs from "./component/about/aboutUs.js";
import PrivacyPolicy from "./component/privacy/Privacy&Policy.jsx";
import InstantPayments from "./component/instandPayment/instantPayments.js";
import PaymentLink from "./component/paymentLink/paymentLink.js";
import UPIpayments from "./component/upi/upiPayments.js";
import Retail from "./component/retail/retail.js";
import Ecommerce from "./component/e-commerce/eCommerce.js";
import Restaurant from "./component/Restaurant/restaurant.js";
import Blog15 from "./component/blog/blog15.js";
import Blog16 from "./component/blog/blog16.js";
import PaymentGateway from "./component/PaymentGateway/PaymentGateway.js";
import Blog17 from "./component/blog/Blog-oct24.js";
import Blog18 from "./component/blog/Blog-oct30.js";
import Blog19 from "./component/blog/Blog-nov6.js";
import Blog20 from "./component/blog/Blog-Nov8.js";
import Blog21 from "./component/blog/Blog-Nov16.js";
import Blog22 from "./component/blog/Blog.Nov20.js";
import Blog23 from "./component/blog/Blog-Nov25.js";
import Blog24 from "./component/blog/Blog-Nov26.js";
import Blog25 from "./component/blog/Blog-Dec3.js";
import Blog26 from "./component/blog/Blog-Dec5.js";
import Blog27 from "./component/blog/Blog-Dec7.js";
import Blog28 from "./component/blog/Blog-Dec10.js";
import Blog29 from "./component/blog/Blog-Dec18.js";
import Blog30 from "./component/blog/Blog-Dec19.js";
import Blog31 from "./component/blog/Blog-Dec23.js";
import Blog32 from "./component/blog/Blog-Jan2.js";
import Blog33 from "./component/blog/Blog-Jan4.js";
import Blog34 from "./component/blog/Blog-Jan8.js";
import Touch from "./component/contact/touch.jsx";
import Terms from "./component/term/terms.js";
import Privacy from "./component/privacy/privacy.jsx";
import Home from "./component/connectedbank/Home.jsx";
import Product from "./component/connectedbank/Product.jsx";
import Aboutus from "./component/connectedbank/Aboutus.jsx";
import ContactUs from "./component/connectedbank/ContactUs.jsx";
import CompleteGuideBlog from "./component/blog/CompleteGuideBlog.js";
import TopFeaturesBlog from "./component/blog/TopFeaturesBlog.js";
import ConnectedBankBlog from "./component/blog/ConnectedBankBlog.js";
import AiPaymentsBlog from "./component/blog/AiPaymentsBlog.js";
import RefundPolicy from "./component/Refund/RefundPolicy.jsx";
import ConnectedProduct from "./component/ConnectedBankProduct/Product.jsx";
import HowConnectedBank from "./component/blog/HowConnectedBank.js";
import ConnectBankSolution from "./component/blog/ConnectBankSolution.js";
import ConnectBankGame from "./component/blog/ConnectBankGame.js";
import SmarterWayBlog from "./component/blog/SmarterWayBlog.js";
import BuildsBetterBlog from "./component/blog/BuildsBetterBlog.js";
import CurrentAccountBlog from "./component/blog/CurrentAccountBlog.js";
import BankServiceGame from "./component/blog/BankServiceGame.js";
import ManualVerifyBlog from "./component/blog/ManualVerifyBlog.js";
import BankServiceIndiaBlog from "./component/blog/BankServiceIndiaBlog.js";
import EscrowBlog from "./component/blog/EscrowBlog.js";
import HealthcareBlog from "./component/blog/HealthcareBlog.js";
import ZeroBalance from "./component/blog/ZeroBalance.js";
import ConnectedPayroll from "./component/blog/ConnectedPayroll.js";
import WhyCurrentAccount from "./component/blog/WhyCurrentAccount.js";
import ConnectedSmartWay from "./component/blog/ConnectedSmartWay.js";
import InvestmentProposal from "./component/Investment/investment.js";
import Blog35 from "./component/blog/Blog35.jsx";
import Blog36 from "./component/blog/Blog36.jsx";
import Blog37 from "./component/blog/Blog37.jsx";
import Blog38 from "./component/blog/Blog38.jsx";
import Blog39 from "./component/blog/Blog39.jsx";
import Blog40 from "./component/blog/blog40.jsx";
import Blog41 from "./component/blog/blog41.jsx";
import Blog42 from "./component/blog/Blog42.jsx";
import Blog43 from "./component/blog/Blog43.jsx";
import Blog44 from "./component/blog/Blog44.jsx";
import Blog45 from "./component/blog/Blog45.jsx";
import Blog46 from "./component/blog/Blog46.jsx";
import Blog47 from "./component/blog/Blog47.jsx";
import Blog48 from "./component/blog/Blog48.jsx";

function App() {
  return (
    <div className="App">
      {/* <Toaster position="bottom-left" reverseOrder={false} /> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/product-collection-payment-solutions-for-healthcare"
            element={<Healthcare />}
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact-us" element={<Touch />} />
          <Route
            path="/product-collection-membership-payment-solutions-in-india"
            element={<Clubassociation />}
          />
          <Route
            path="/product-collection-housing-payments-solutions-in-india"
            element={<Housingsociety />}
          />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blogpage" element={<BlogPage />} />
          <Route path="/career" element={<Career />} />
          <Route path="/news" element={<News />} />
          <Route path="/certificate" element={<Certificate />} />
          <Route path="/termsandcondition" element={<Term />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-and-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/instant-payments" element={<InstantPayments />} />
          <Route path="/payment-link" element={<PaymentLink />} />
          <Route
            path="/product-connected-banking-services"
            element={<ConnectedProduct />}
          />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/investment-proposal" element={<InvestmentProposal />} />
          <Route
            path="/product/payin-service-providers"
            element={<UPIpayments />}
          />
          <Route path="/retail" element={<Retail />} />
          <Route path="/restaurant" element={<Restaurant />} />
          <Route path="/e-commerce" element={<Ecommerce />} />
          <Route
            path="/product-collection-education-payment-providers-in-india"
            element={<Education />}
          />
          <Route path="/pricings" element={<Pricing />} />
          <Route path="/career/director-operations" element={<Backend />} />
          <Route
            path="/career/lead-generation-executive"
            element={<LeadGenerationExecutive />}
          />
          <Route path="/career/manager-IT" element={<ManagerIT />} />
          <Route
            path="/career/marketing-strategist"
            element={<MarketingStrategist />}
          />
          <Route
            path="/career/pr-marketing-and-profile-maintenance-analyst"
            element={<PrMarketting />}
          />
          <Route
            path="/career/tech-support-or-sales-support"
            element={<TechSupport />}
          />
          <Route path="/event" element={<Event />} />
          <Route path="/event/money-expo" element={<EventsPage />} />
          <Route path="/event/global-fintech-fest" element={<Gff />} />
          <Route
            path="/product/payouts-service-provider-in-india"
            element={<Payout />}
          />
          <Route path="/product-partner" element={<PartnerPage />} />
          <Route path="/recurring-payments" element={<RecurringPayments />} />
          <Route
            path="/the-ultimate-guide-to-choosing-the-best-payout-service-in-india"
            element={<Blog2 />}
          />
          <Route
            path="/top-10-payout-solutions-in-india-an-in-depth-guide"
            element={<Blog3 />}
          />
          <Route
            path="/the-growing-trend-indian-businesses-transitioning-to-bulk-payout-solution"
            element={<Blog5 />}
          />
          <Route
            path="/the-essential-role-of-payout-service-providers-in-india-digital-economy"
            element={<Blog6 />}
          />
          <Route
            path="/selecting-the-optimal-payout-service-in-india-a-comprehensive-guide"
            element={<Blog7 />}
          />
          <Route
            path="/payins-vs-payouts-the-ultimate-guide-to-understanding-both"
            element={<Blog8 />}
          />
          <Route
            path="/mastering-payouts-essential-insights-on-what-they-are-and-who-can-use-them"
            element={<Blog9 />}
          />
          <Route
            path="/from-transactions-to-trust-how-e-Commerce-platforms-use-payout-services"
            element={<Blog10 />}
          />
          <Route
            path="/features-of-the-best-payout-settlement-api-solution-in-india"
            element={<Blog11 />}
          />
          <Route
            path="/how-payout-services-enhance-employee-satisfaction-and-retention"
            element={<Blog12 />}
          />
          <Route
            path="/haodaPay-payout-services-your-go-to-guide-for-fast-and-secure-online-money-transfers"
            element={<Blog13 />}
          />
          <Route
            path="/what-challenges-have-you-faced-with-payout-services-in-your-finance-journey"
            element={<Blog14 />}
          />
          <Route
            path="/Comprehensive-Corporate-Payout-Solutions"
            element={<Blog15 />}
          />
          <Route
            path="/How-Payout-Services-Can-Help-India’s-Growing-Freelance-Workforce"
            element={<Blog16 />}
          />
          <Route
            path="/finding-the-perfect-payment-gateway-for-indian-enterprises"
            element={<Blog35 />}
          />
          <Route
            path="/the-hidden-causes-of-reconciliation-errors-and-their-solutions"
            element={<Blog36 />}
          />
          <Route
            path="/upi-fraud-prevention-how-businesses-can-stay-safe-from-digital-scams"
            element={<Blog37 />}
          />
          <Route
            path="/india-subscription-billing-challenges-smart-solutions-global-businesses"
            element={<Blog38 />}
          />
          <Route
            path="/how-digital-payments-are-fueling-indian-business-growth"
            element={<Blog39 />}
          />
          <Route
            path="/the-role-of-secure-online-payments-in-building-trust"
            element={<Blog40 />}
          />
          <Route
            path="/dynamic-qr-code-static-qr-code-for-business"
            element={<Blog41 />}
          />
          <Route
            path="/the-complete-guide-to-high-converting-checkout-experience-in-2026"
            element={<Blog42 />}
          />
          <Route
            path="/payment-gateway-mistakes-that-cause-cart-abandonment"
            element={<Blog43 />}
          />
          <Route
            path="/Payment-Gateway-for-Insurance-Essential-Features-to-Consider"
            element={<Blog44 />}
          />
          <Route
            path="/how-to-prevent-friendly-fraud-and-protect-your-business"
            element={<Blog45 />}
          />
          <Route
            path="/shopify-payment-gateway-integration-a-simple-guide-for-businesses"
            element={<Blog46 />}
          />
          <Route
            path="/corporate-card-or-business-credit-card-which-is-right-for-your-business"
            element={<Blog47 />}
          />
           <Route
            path="/corporate-card-for-businesses-benefits-every-indian-company-should-know"
            element={<Blog48 />}
          />
          <Route
            path="/product-payment-gateway-services-in-india"
            element={<PaymentGateway />}
          />
          <Route
            path="/a-complete-guide-to-connected-banking-what-it-is-and-how-it-functions"
            element={<CompleteGuideBlog />}
          />
          <Route
            path="/top-features-every-business-needs-in-a-connected-banking-platform"
            element={<TopFeaturesBlog />}
          />
          <Route
            path="/connected-banking-services-the-next-big-shift-in-business-finance"
            element={<ConnectedBankBlog />}
          />
          <Route
            path="/ai-in-payments-shaping-the-future-of-business-in-2026"
            element={<AiPaymentsBlog />}
          />
          <Route
            path="/how-connected-banking-reduces-errors-and-financial-reconciliation-time"
            element={<HowConnectedBank />}
          />
          <Route
            path="/connected-banking-a-game-changer-for-e-commerce-and-subscription-brands"
            element={<ConnectBankGame />}
          />
          <Route
            path="/connected-banking-solutions-for-faster-settlements-and-complete-financial-visibility"
            element={<ConnectBankSolution />}
          />
          <Route
            path="/connected-banking-the-smarter-way-to-manage-multiple-current-accounts"
            element={<SmarterWayBlog />}
          />
          <Route
            path="/how-connected-banking-builds-better-financial-control-for-SMEs"
            element={<BuildsBetterBlog />}
          />
          <Route
            path="/the-importance-of-a-current-account-with-connected-banking-for-modern-businesses"
            element={<CurrentAccountBlog />}
          />
          <Route
            path="/why-connected-banking-services-are-a-game-changer-for-CFOs"
            element={<BankServiceGame />}
          />
          <Route
            path="/manual-verification-vs-API-driven-vendor-onboarding-why-the-shift-happens"
            element={<ManualVerifyBlog />}
          />
          <Route
            path="/connected-banking-services-in-india-turning-banking-data-into-actionable-insights"
            element={<BankServiceIndiaBlog />}
          />
          <Route
            path="/why-escrow-is-becoming-essential-for-enterprises-by-2026"
            element={<EscrowBlog />}
          />
          <Route
            path="/healthcare-payment-processing-a-complete-guide-for-hospitals&clinics"
            element={<HealthcareBlog />}
          />
          <Route
            path="/zero-balance-current-account:benefits-and-how-to-open-a-current-account?"
            element={<ZeroBalance />}
          />

          <Route
            path="/how-connected-banking-simplifies-payroll-and-expense-management-for-indian-businesses"
            element={<ConnectedPayroll />}
          />
          <Route
            path="/why-a-current-account-with-connected-canking-features-is-essential-for-your-business"
            element={<WhyCurrentAccount />}
          />
          <Route
            path="/connected-banking:a-smarter-way-to-manage-vendor-payouts"
            element={<ConnectedSmartWay />}
          />

          {/* connected bank */}
          <Route path="/connected-bank" element={<Home />} />
          <Route path="/product/connected-bank" element={<Product />} />
          <Route path="/connected-bank/about-us" element={<Aboutus />} />
          <Route path="/connected-bank/contact-us" element={<ContactUs />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
